import * as React from 'react';
export var CommunicateListContext = React.createContext([]);
export var CommunicateListProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), communicateList = _b[0], setCommunicateList = _b[1];
    var value = [communicateList, setCommunicateList];
    return React.createElement(CommunicateListContext.Provider, { value: value }, children);
};
